import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PropertyUnit } from '@modules/projects/details/leases/tenants.types';

@Injectable({ providedIn: 'root' })
export class PropertyUnitService extends BaseService {
  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient);
  }

  search(
    propertyId: number,
    sort = { sort: 'unit_number', order: 'asc' },
    maxPageSize = 150,
  ): Observable<PropertyUnit[]> {
    return this.httpClient
      .get<any>(`properties/${propertyId}/property_units?sort=${sort.sort}&order=${sort.order}&per_page=${maxPageSize}`)
      .pipe(
        map(({ property_units }: { property_units: PropertyUnit[] }) => {
          return property_units;
        }),
      );
  }

  update(propertyId: number, propertyUnit: PropertyUnit): Observable<PropertyUnit> {
    return this.httpClient
      .put<any>(`properties/${propertyId}/property_units/${propertyUnit.id}`, {
        property_unit: propertyUnit,
      })
      .pipe(
        map(({ property_unit }) => {
          return property_unit;
        }),
      );
  }
}
